@if (variant() === 'pill' && dot()) {
    <span class="dot"></span>
}
<ng-content></ng-content>
